import { getFileSizeStringFromByte, getFileSuffix } from 'app/utils/file'
import { truncateText } from 'app/utils/text'
import { DownloadFile, FileTypeBg } from 'app/components/icons'
import clsx from 'clsx'
import styles from './styles.module.scss'

function FileMessage({ title, renderRepliedMsgPreview, fileName, fileSize, url, className, type }) {
  const suffix = getFileSuffix(fileName)
  const formattedFileSize = getFileSizeStringFromByte(fileSize)

  return (
    <div data-type={type} title={title} className={clsx(styles.file_message, className)}>
      {renderRepliedMsgPreview}
      <div className={styles.file_message_container}>
        <div className={clsx(styles.file_type_container, styles.text_red)}>
          <FileTypeBg />
          <span className={styles.file_type_suffix}>{suffix}</span>
        </div>
        <div className={styles.info_download_container}>
          <div className={styles.file_info}>
            <span className={styles.file_name}>{truncateText(fileName, 18)}</span>
            <span className={styles.file_size}>{formattedFileSize}</span>
          </div>
          <a target="blank" href={url}>
            <div className={styles.download_file_container}>
              <DownloadFile />
            </div>
          </a>
        </div>
      </div>
    </div>
  )
}

export default FileMessage
